import { Modal, PrimaryDataTable, TableColumn, TableRow } from "@component";
import { ActivityDetailModalProps } from "@presenter";
import React from "react";

const UserTendencyKeywordModal = ({ data, isLoading }: ActivityDetailModalProps) => {
  return (
    <Modal width={"80%"} modalKey={"modalKeyword"} title={"사용자 키워드 성향 상세"} footer={false}>
      <PrimaryDataTable headers={["키워드", "점수", "최고 점수 대비 백분율"]} isLoading={isLoading} useFilter={false} pagination={false}>
        {
          data ? data.keywordList?.map((item: any, index: number) => {
            const { key, score } = item
            const percentage = score / data.keywordList[0].score * 100
            return (
              <TableRow
                key={index}
                enableDetailButton={true}
                enableOverlay={false}
                onClickDetailButton={() => {}}>
                <TableColumn align={"center"}>{ key }</TableColumn>
                <TableColumn align={"center"}>{ score }점</TableColumn>
                <TableColumn align={"center"} percentage={percentage}>{ percentage.toFixed(1) }%</TableColumn>
              </TableRow>
            )
          }) : <></>
        }
      </PrimaryDataTable>
    </Modal>
  )
}

export default UserTendencyKeywordModal
